import React from 'react';
import { useParams } from 'react-router';

import { useGetProjectTags } from '@/src/components/project/Tags/api/projectTags';
import { TagsFilter } from '@/src/components/project/Tags/components/Table/Header/Filters/TagsFilter/TagsFilter';

import { useLibrarySearchParamsContext } from '../../../store/filters.store';
import { useGetProjectPermissions } from '@/src/components/project/api/getProjectPermissions';

export const LibraryTagsFilter = () => {
  const { filter, setParams } = useLibrarySearchParamsContext();
  const { projectId } = useParams<{ projectId: string }>();
  const libraryPermissionsQuery = useGetProjectPermissions({
    projectId: +projectId,
  });
  const hasLibraryTagsAccess = libraryPermissionsQuery.data?.data.library.access;

  const tagsMutation = useGetProjectTags(projectId, { enabled: hasLibraryTagsAccess });

  if (!hasLibraryTagsAccess) {
    return <span>Tags</span>;
  }

  return <TagsFilter tags={tagsMutation.data || []} filter={filter} setParams={setParams} />;
};
